module.exports = __webpack_public_path__ + "813fd8df063072d04906817910a56df0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/floor_items/palm-tree.png
// module id = 3214
// module chunks = 0